// Angular
import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

// Local
import { ROUTES } from '@routes';
import { JudgeReviewDataService } from '../shared/services/judge-review-data.service';

/**
 * Guards the Judge Review Receipt route. The receipt is rendered from the
 * in-memory {@link JudgeReviewSubmitResponse} stored by the Confirmation page on
 * submit (the server working copy is deleted on submit, so a resolver can't
 * re-fetch it). On a hard refresh / direct navigation there is no response, so
 * we redirect back to the queue — as a route guard rather than a constructor
 * check, this prevents the receipt component from instantiating at all.
 */
export const judgeReviewReceiptGuard: CanActivateFn = () => {
  const dataService = inject(JudgeReviewDataService);
  const router = inject(Router);

  return dataService.hasSubmitResponse()
    ? true
    : router.parseUrl(`/${ROUTES.JUDGE_REVIEW_LIST}`);
};
